var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [
        _vm.organizationUnitId
          ? _c("AdminNavigationV2", { attrs: { tid: _vm.organizationUnitId } })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isAccepted
      ? _c("div", [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-7" }, [
                _c(
                  "h1",
                  {
                    staticStyle: {
                      "font-size": "2em",
                      "font-weight": "300",
                      color: "#33475b",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.isServiceUser
                            ? "Manage service account"
                            : "Manage user"
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.isDeleted
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-link btn-sm",
                          attrs: {
                            href: `/#/admin/organizations/users/manage/details/${_vm.id}`,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-pencil",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Edit")]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isLocked
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-link btn-sm",
                              on: { click: _vm.handleUnlockUserCommandV1 },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-unlock-alt",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Unlock")]),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn btn-link btn-sm",
                              on: { click: _vm.handleLockUserCommandV1 },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-lock",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Lock")]),
                            ]
                          ),
                      _vm._v(" "),
                      !_vm.isServiceUser
                        ? _c("div", { staticClass: "dropdown d-inline" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu p-3 shadow-sm",
                                staticStyle: { width: "400px" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    on: {
                                      click: _vm.handleResetPasswordCommandV1,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-key",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Reset password")]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group form-check" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.sendPasswordToEmailEnabled,
                                          expression:
                                            "sendPasswordToEmailEnabled",
                                        },
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "sendPasswordOnEmail",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.sendPasswordToEmailEnabled
                                        )
                                          ? _vm._i(
                                              _vm.sendPasswordToEmailEnabled,
                                              null
                                            ) > -1
                                          : _vm.sendPasswordToEmailEnabled,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.sendPasswordToEmailEnabled,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.sendPasswordToEmailEnabled =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.sendPasswordToEmailEnabled =
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.sendPasswordToEmailEnabled = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form-check-label",
                                        attrs: { for: "sendPasswordOnEmail" },
                                      },
                                      [
                                        _vm._v(
                                          "Send password on additional email"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sendPasswordToEmail,
                                      expression: "sendPasswordToEmail",
                                    },
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.sendPasswordToEmailEnabled,
                                      expression: "sendPasswordToEmailEnabled",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "email",
                                    placeholder: "Email",
                                  },
                                  domProps: { value: _vm.sendPasswordToEmail },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.sendPasswordToEmail =
                                        $event.target.value
                                    },
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isServiceUser
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-link btn-sm",
                              attrs: {
                                href: `/#/organizations/accesstokens/manage/${_vm.id}`,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-key",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Manage API keys")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isServiceUser
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-link btn-sm",
                              on: {
                                click:
                                  _vm.handleSignoutFromAllSessionsCommandV1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-ban",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Revoke sessions")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link btn-sm",
                          on: { click: _vm.handleDisableUserCommandV1 },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-remove",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Delete")]),
                        ]
                      ),
                    ])
                  : _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link btn-sm",
                          on: { click: _vm.handleEnableUserCommandV1 },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-undo",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.isServiceUser
                                  ? "Restore service account"
                                  : "Restore user"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            !_vm.isDeleted
              ? _c("div", [
                  _c("h3", [_vm._v(_vm._s(_vm.displayName))]),
                  _vm._v(" "),
                  _c("h6", [_vm._v(_vm._s(_vm.email))]),
                  _vm._v(" "),
                  _c("h6", [
                    _vm.isServiceUser
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-info",
                            attrs: { title: "Service Account" },
                          },
                          [_vm._v("Service Account")]
                        )
                      : _c("span", [_vm._v(_vm._s(_vm.userType))]),
                  ]),
                  _vm._v(" "),
                  _vm.isServiceUser
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-info mt-3",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-info-circle",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Service Account:")]),
                          _vm._v(
                            " This account is used for API access and automation. It cannot sign in through the web UI and uses API keys for authentication.\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: {
                        href: `/#/admin/organizations/users/manage/roles/${_vm.id}`,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Manage roles\n                "
                      ),
                    ]
                  ),
                ])
              : _c("div", [
                  _c("h3", { staticClass: "fg-color-red" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.displayName) +
                        " is deleted\n                    "
                    ),
                    _vm.isServiceUser
                      ? _c("span", { staticClass: "badge badge-info ml-2" }, [
                          _vm._v("Service Account"),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("h6", [_vm._v(_vm._s(_vm.email))]),
                ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            !_vm.isDeleted
              ? _c(
                  "div",
                  [
                    _c("h4", [_vm._v("Workspaces")]),
                    _vm._v(" "),
                    _vm._l(_vm.workspaces, function (w) {
                      return _c("h6", [_vm._v(_vm._s(w.Name))])
                    }),
                    _vm._v(" "),
                    _vm.workspaces.length == 0
                      ? _c("h6", [_vm._v("No workspaces assigned")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-secondary btn-sm",
                        attrs: {
                          href: `/#/admin/organizations/users/manage/workspaces/${_vm.id}`,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Manage workspaces\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isServiceUser
                      ? _c("p", { staticClass: "text-muted mt-2" }, [_vm._m(1)])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ])
      : _vm.isRequested
      ? _c("div", [
          _vm._m(2),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("h3", [_vm._v(_vm._s(_vm.displayName))]),
            _vm._v(" "),
            _vm.displayName != _vm.email
              ? _c("h6", [_vm._v(_vm._s(_vm.email))])
              : _vm._e(),
            _vm._v(" "),
            _vm.requestedBy
              ? _c("h6", [_vm._v("Requested by " + _vm._s(_vm.requestedBy))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-success",
                on: { click: _vm.handleAcceptUserAccessRequestCommandV1 },
              },
              [_vm._v("Accept")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-danger",
                on: { click: _vm.handleRejectUserAccessRequestCommandV1 },
              },
              [_vm._v("Reject")]
            ),
          ]),
        ])
      : _vm.isRejected
      ? _c("div", [
          _vm._m(3),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("h3", { staticClass: "text-danger" }, [
              _vm._v("Rejected user access for " + _vm._s(_vm.displayName)),
            ]),
            _vm._v(" "),
            _vm.displayName != _vm.email
              ? _c("h6", [_vm._v(_vm._s(_vm.email))])
              : _vm._e(),
            _vm._v(" "),
            _vm.requestedBy
              ? _c("h6", [_vm._v("Requested by " + _vm._s(_vm.requestedBy))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-success",
                on: { click: _vm.handleAcceptUserAccessRequestCommandV1 },
              },
              [_vm._v("Accept")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-link",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _c("i", { staticClass: "fa fa-key", attrs: { "aria-hidden": "true" } }),
        _vm._v(" "),
        _c("span", [_vm._v("Reset password")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("small", [
      _c("i", { staticClass: "fa fa-info-circle" }),
      _vm._v(" Service accounts can have workspace access for API operations."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage user access request")]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage user access request")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }